import { useEffect, useState } from "react";

export const useActiveElements = ( data ) => {
  const [activeData, setActiveData] = useState([]);
  
  useEffect(() => {
    setActiveData( data.map((item, index) => {
      if(index === 0) {
        return {
          ...item,
        active: true
        }
      } else {
        return {
          ...item,
        active: false
        }
        
      }
    }) )
  }, [data])

  const handleActive = (id) => {
    setActiveData(activeData.map(item => {
      if(item.id === id) {
        return {
          ...item,
          active: true
        }
      } else {
        return {
          ...item, active: false
        }
      }
    }))
  }
  const handleActiveTab = (index) => {
    setActiveData(activeData.map((item, i) => {
      
      if(i === index) {
        return {
          ...item,
          active: true
        }
      } else {
        return {
          ...item, active: false
        }
      }
    }))
  }
  
  return { handleActive, activeData, handleActiveTab }
}